import { FC, memo, useCallback } from 'react';

import * as Compare from '@Queries/Compare';
import Like, { LikeProps } from '@UI/Like';
import { ProductData } from '@Types/Product';

export interface ProductLikeProps extends LikeProps {
  product: ProductData;
}

const ProductLike: FC<ProductLikeProps> = (props) => {
  const { product, onClick, ...restProps } = props;
  const { data: hasInCompare } = Compare.useInCompare(product.id);
  const addInCompare = Compare.useAdd().mutate;
  const removeFromCompare = Compare.useRemove().mutate;

  const handleClick = useCallback(
    (e) => {
      if (hasInCompare) {
        removeFromCompare(product.id);
      } else {
        addInCompare(product.id);
      }

      if (onClick) onClick(e);
    },
    [addInCompare, removeFromCompare, hasInCompare, onClick, product],
  );

  return <Like {...restProps} liked={hasInCompare} onClick={handleClick} />;
};

export default memo(ProductLike);
